import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Inmediatamente después del pago recibís un mail con el link de descarga de todos los PDFs. El acceso es de por vida.'
}, {
  q: '¿Sirve si soy pediatra general o recién empiezo a hacer guardias?',
  a: 'Exactamente para eso está diseñado. Te da las herramientas paso a paso para evaluar, estabilizar y derivar o internar correctamente, que es exactamente lo que se espera de un médico en la guardia pediátrica.'
}, {
  q: '¿Está en español argentino?',
  a: 'Todo el contenido está escrito en español rioplatense, adaptado a la legislación argentina, con referencias a la Ley 26.061, el sistema de salud y los organismos de protección del país.'
}, {
  q: '¿Los 6 bonos están incluidos en todas las ofertas?',
  a: 'Sí. Los 6 bonos de guardia están incluidos en todos los niveles (PRO, Elite y Completo).'
}, {
  q: '¿Sirve para el concurso de residencia de pediatría?',
  a: 'Sí. El manejo de urgencias, el conocimiento del marco legal específico y los protocolos clínicos te diferencian en la evaluación del concurso.'
}, {
  q: '¿Qué diferencia tiene con los libros de pediatría tradicionales?',
  a: 'Los libros de pediatría son teóricos y extensos. Este sistema es 100% práctico, diseñado para la trinchera de la guardia, e incluye la complejidad legal de actuar ante urgencias en Argentina.'
}, {
  q: '¿Para qué nivel está pensado?',
  a: 'Para pediatras de guardia, residentes de pediatría, médicos generalistas que atienden niños en urgencias y profesionales que se preparan para el concurso de residencia pediátrica.'
}, {
  q: '¿Por qué elegir el Sistema Completo o Elite y no el PRO base?',
  a: 'El PRO te da todo el sistema clínico de guardia. El Elite agrega el sistema de protección legal. El Sistema Completo suma además todo el Megapack de Salud Mental. Si atendés niños, estar cubierto en urgencias, legal y salud mental es la protección definitiva.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-slate-50 py-8 sm:py-28" data-id="element-162">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-163">
        <div className="text-center mb-6 sm:mb-16" data-id="element-164">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-slate-500 uppercase mb-1.5 sm:mb-3" data-id="element-165">
            Dudas Comunes
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-166">
            Preguntas Frecuentes
          </p>
        </div>

        <div className="space-y-2 sm:space-y-4" data-id="element-167">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`bg-white rounded-xl sm:rounded-2xl ring-1 transition-all ${isOpen ? 'ring-blue-200 shadow-md' : 'ring-slate-200 shadow-sm hover:ring-slate-300'}`} data-id="element-168">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left px-3 py-3 sm:px-6 sm:py-5 flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded-xl sm:rounded-2xl" aria-expanded={isOpen} data-id="element-169">
                  <span className="font-semibold text-xs sm:text-base text-slate-900 pr-3 sm:pr-8" data-id="element-170">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-3.5 h-3.5 sm:w-5 sm:h-5 text-slate-400 flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180 text-blue-500' : ''}`} data-id="element-171" />
                </button>
                <AnimatePresence data-id="element-172">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} className="overflow-hidden" data-id="element-173">
                      <div className="px-3 pb-3 sm:px-6 sm:pb-5 text-[10px] sm:text-base text-slate-600 leading-relaxed" data-id="element-174">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}